import React from 'react';
import { Navigate } from 'react-router-dom';
import moment from 'moment';
import queryString from 'query-string';
import config from 'config';
import Navigation from '../_components/Navigation';
import { userService, jobService } from '../_services';
import _ from 'lodash';
import { withAuthenticatedUser } from 'Components/withAuthenticatedUser';
import { withRouter } from 'Components/withRouter';
import styles from './JobPage.module.css';

class JobPage extends React.Component {
    goBack = () => { this.props.router.navigate(-1); }
    copyAsNewJob = () => {
        localStorage.setItem('Job.' + this.state.job_id, JSON.stringify(this.state));
        this.setState({ redirect: '/?rebook=' + this.state.job_id });
    }
    
    constructor(props) {
        super(props);
   
        const values = queryString.parse(this.props.router.location.search);
        var jobid = values.id;
        this.formatter = new Intl.NumberFormat('en-NZ', { style: 'currency', currency: 'NZD' });
       
        this.state = {
            // account display labels
            ref1_label: "Reference 1",
            ref1_required: "Y",
            ref2_label: "Ref 2",
            ref2_required: "N",
            ref3_label: "Ref 3",
            ref3_required: "N",
            // job data
            booked_by: "",
            account: "",
            account_name: "",
            ref1: "",
            ref2: "",
            ref3: "",
            pickup_contact: "",
            pickup_phone: "",
            pickup_company: "",
            pickup_address1: "",
            pickup_address2: "",
            pickup_suburb: "",
            pickup_instructions: "",
            pickup_instructions_without_contact: "",
            delivery_contact: "",
            delivery_phone: "",
            delivery_company: "",
            delivery_address1: "",
            delivery_address2: "",
            delivery_suburb: "",
            delivery_instructions: "",
            delivery_instructions_without_contact: "",
            item_type: "",
            quantity: "",
            weight: "",
            vehicle_type: "",
            vehicle_type_descr: "",
            dangerous_goods: false,
            pickup_date: "",
            pickup_time: "",
            delivery_email: "",
            service: "",
            // status
            job_id: jobid,
            status: "",
            price: 0,
            vfr: 0,
            total: 0,
            job_number: "",
            ready_datetime: "",
            pickup: { completed: false, time: "", signer_name: "" },
            delivery: { completed: false, time: "", signer_name: "", image: false },
            url: "",
            delivered_time: "",
            delivered_sig_name: "",
            accountPrintLabelFormat: "",
            defaultPrintLabelFormat: "",
            markupPercent: 0.0
        };

        this.openPopup = this.openPopup.bind(this);
        this.printLabel = this.printLabel.bind(this);
        this.printReturnLabel = this.printReturnLabel.bind(this);
        this.applyMarkup = this.applyMarkup.bind(this);
    }
    
    componentDidMount() {

        jobService.getPrintLabelFormats()
            .then(printLabelFormats => {
                var defaultFormat = _.find(printLabelFormats, f => f.default === true);

                if (defaultFormat) {
                    this.setState({
                        defaultPrintlabelFormat: defaultFormat
                    });
                }
                
            })
            .catch(error => {
                console.log(error)
            });
        
        userService.getJob(this.state.job_id)
        .then(job => {
            var pickup = job.events.find((e) => e.type && e.type.toLowerCase() == "pickup");
            var delivery = job.events.find((e) => e.type && e.leg_number == job.number_of_legs && e.type.toLowerCase() == "delivered");
            this.setState({
                booked_by: job.caller_name || "",
                account: job.account_code || "",
                account_name: job.account || "",
                ref1: job.reference1 || "",
                ref2: job.reference2 || "",
                ref3: job.reference3 || "",
                pickup_contact: job.pickup_contact || "",
                pickup_phone: job.pickup_phone || "",
                pickup_company: job.pickup_company || "",
                pickup_address1: job.pickup_address1 || "",
                pickup_address2: job.pickup_address2 || "",
                pickup_suburb: job.pickup_suburb || "",
                pickup_instructions: job.pickup_instructions || "",
                pickup_instructions_without_contact: job.pickup_instructions_without_contact || "",
                delivery_contact: job.delivery_contact || "",
                delivery_phone: job.delivery_phone || "",
                delivery_company: job.delivery_company || "",
                delivery_address1: job.delivery_address1 || "",
                delivery_address2: job.delivery_address2 || "",
                delivery_suburb: job.delivery_suburb || "",
                delivery_instructions: job.delivery_instructions || "",
                delivery_instructions_without_contact: job.delivery_instructions_without_contact || "",
                item_type: job.item_type || "",
                quantity: job.pieces || "",
                weight: job.weight || "",
                vehicle_type: job.vehicle_type || "",
                vehicle_type_descr: job.vehicle_type_descr || "",
                dangerous_goods: job.dangerous_goods || false,
                pickup_date: moment(job.ready_datetime).format("DD/MM/YYYY"),
                pickup_time: moment(job.ready_datetime).format("HH:mm"),
                delivery_email: job.delivery_notification || "",
                service: job.service_description || "",
                // status
                status: job.status || "",
                price: job.price || 0,
                vfr: job.vfr || 0,
                total: (job.price || 0) + (job.vfr || 0),
                job_number: job.job_number || "",
                ready_datetime: moment(job.ready_datetime).format("DD/MM/YYYY HH:mm") || "",
                pickup: {
                    completed: pickup ? true : false,
                    time: pickup && pickup.time ? moment(pickup.time).format("DD/MM/YYYY HH:mm") : '',
                    signer_name: pickup && pickup.name ? pickup.name : ''
                    },
                delivery: {
                    completed: delivery ? true : false,
                    time: delivery && delivery.time ? moment(delivery.time).format("DD/MM/YYYY HH:mm") : '',
                    signer_name: delivery && delivery.name ? delivery.name : '',
                    image: delivery && delivery.images && delivery.images.length > 0,
                    images: (delivery && delivery.images) ? delivery.images : null
                    },
                url: job.uri || "",
                delivered_time: job.delivered_time || "",
                delivered_sig_name: job.delivered_sig_name || "",
                redirect: false,
                isReturnJob: job.isReturnJob,
                markupPercent: job.markup_percentage
            });
            
            userService.getAccountDetails(job.account_code)
            .then(details => {
                this.setState({
                    ref1_label: details.ref1_label,
                    ref2_label: details.ref2_label,
                    ref3_label: details.ref3_label,
                    ref1_required: details.ref1_required,
                    ref2_required: details.ref2_required,
                    ref3_required: details.ref3_required,
                    accountPrintLabelFormat: details.job_label_format
                });
            });
        })
        .catch(error => {
            console.log(error);
        });
    }
    
    openPopup() {
        if (this.state.url)
            window.open(this.state.url, "popup_id", "scrollbars,resizable,width="+720+",height="+540);
    }

    printLabel() {

        var jobId = this.state.job_id;
        
        jobService.getPrintLabelGuid(jobId)
            .then(response =>{
                var guid = response;
                var url = new URL(`${config.apiUrl}/jobs/${jobId}/print/${guid}`);

                var printLabelFormat =
                    this.props.authenticatedUser?.defaultPrintLabelFormat ||
                    this.state.accountPrintLabelFormat ||
                    this.state.defaultPrintLabelFormat;

                if (printLabelFormat) {
                    url.searchParams.set('printLabelFormat', printLabelFormat);
                }

                window.open(url);
            });
    }

    printReturnLabel() {

        var jobId = this.state.job_id;

        jobService.getPrintLabelGuid(jobId, 2)
            .then(response =>{
                var guid = response;
                var url = new URL(`${config.apiUrl}/jobs/${jobId}/print/${guid}`);

                var printLabelFormat =
                    this.props.authenticatedUser?.defaultPrintLabelFormat ||
                    this.state.accountPrintLabelFormat ||
                    this.state.defaultPrintLabelFormat;

                if (printLabelFormat) {
                    url.searchParams.set('printLabelFormat', printLabelFormat);
                }

                window.open(url);
            });

    }

    applyMarkup(amount) {
        return amount * (1 + this.state.markupPercent / 100);
    }

    render() {
        if(this.state.redirect)
            return <Navigate push to={this.state.redirect}/>;

        var privileges = null;

        if (this.props.authenticatedUser) {
            privileges = this.props.authenticatedUser.privileges;
        }

        var canViewSignature = privileges && _.some(privileges, ['description', 'Can View Signatures']);
        var canViewPrice = privileges && _.some(privileges, ['description', 'Can View Price']);

        var trackMyDriver = null;

        if (this.state.url && this.state.url !== "")
            trackMyDriver = (<small><span>&nbsp;(<a onClick={this.openPopup}>Track my courier</a>)</span></small>);

        var signatures = null;

        if (canViewSignature) {
            if (this.state.delivery.images) {
                var image = _.head(this.state.delivery.images);

                signatures = image && <img class='jobSig' src={"data:" + image.imageType + ";base64, " + image.imageData} />
            }
        }

        return (
            <div id="job-details">
                <Navigation active="query" authenticatedUser={this.props.authenticatedUser} />
                <div className="container-fluid padding-lr55 bg-form flat">
                    <div className="row">
                        <div className="col-xs-12 col-sm-6">
                            <div className="row h3">
                                <div className="col-xs-12">Job {this.state.job_number} - {this.state.status}{trackMyDriver}</div>
                            </div>
                        </div>
                        <div className={`col-xs-12 col-sm-6 ${styles.buttonRow}`}>
                            <button className="btn btn-dl-green" onClick={this.goBack}>BACK</button>
                            <button className="btn btn-dl-green" onClick={this.copyAsNewJob}>COPY AS NEW JOB</button>
                            <button className="btn btn-dl-green" onClick={this.printLabel}>PRINT LABEL</button>
                            {this.state.isReturnJob &&
                                <button className="btn btn-dl-green" onClick={this.printReturnLabel}>RETURN LABEL</button>
                            }
                        </div>
                    </div>
                </div>

                <div className="container-fluid padding-lr55 bg-form">
                    <div className="row">
                        <div className="col-sm-4 col-lg-3">
                            <div className="row h3">
                                <div className="col-xs-12">Account</div>
                            </div>
                            <div className="row">
                                <div className="col-xs-12">
                                    <div className="form-group">
                                        <span className="labeltext">Booked By</span>
                                        <input className="form-control" type="text" name="booked_by" value={this.state.booked_by} readOnly/>
                                    </div>
                                    <div className="form-group">
                                        <span className="labeltext">Account</span>
                                        <input className="form-control" type="text" name="account" value={this.state.account} readOnly/>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="row h3">
                                <div className="col-xs-12">References</div>
                            </div>
                            <div className="row">
                                <div className="col-xs-12">
                                    <div className={"form-group " + (this.state.ref1_required == "H" ? " hide" : "")}>
                                        <span className="labeltext">{this.state.ref1_label}</span>
                                        <input className="form-control" type="text" name="ref1" value={this.state.ref1} readOnly/>
                                    </div>
                                    <div className={"form-group " + (this.state.ref2_required == "H" ? " hide" : "")}>
                                        <span className="labeltext">{this.state.ref2_label}</span>
                                        <input className="form-control" type="text" name="ref2" value={this.state.ref2} readOnly/>
                                    </div>
                                </div>
                            </div>
                        </div>
                      
                        <div className="col-sm-8 col-lg-6">
                            <div className="container-fluid padding-lr0">
                                <div className="row">
                                    <div className="col-sm-6">
                                        <div className="row h3">
                                            <div className="col-xs-12">Pickup</div>
                                        </div>
                                        <div className="row">
                                            <div className="col-xs-12">
                                                <div className="form-group">
                                                    <span className="labeltext">Contact</span>
                                                    <input className="form-control" type="text" name="pickup_contact" value={this.state.pickup_contact} readOnly/>
                                                </div>
                                                <div className="form-group">
                                                    <span className="labeltext">Phone</span>
                                                    <input className="form-control" type="text" name="pickup_phone" value={this.state.pickup_phone} readOnly/>
                                                </div>
                                                <div className="form-group">
                                                    <span className="labeltext">Company</span>
                                                    <input className="form-control" type="text" name="pickup_company" value={this.state.pickup_company} readOnly/>
                                                </div>
                                                <div className="form-group">
                                                    <span className="labeltext">Address</span>
                                                    <input className="form-control" type="text" name="pickup_address1" value={this.state.pickup_address1} readOnly/>
                                                    <input className="form-control" type="text" name="pickup_address2" value={this.state.pickup_address2} readOnly/>
                                                </div>
                                                <div className="form-group">
                                                    <span className="labeltext">Suburb</span>
                                                    <input className="form-control" type="text" name="pickup_suburb" value={this.state.pickup_suburb} readOnly/>
                                                </div>
                                                <div className="form-group">
                                                    <span className="labeltext">Instructions</span>
                                                    <textarea className="form-control" rows="3" name="pickup_instructions" value={this.state.pickup_instructions} readOnly/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="row h3">
                                            <div className="col-xs-12">Delivery</div>
                                        </div>
                                        <div className="row">
                                            <div className="col-xs-12">
                                                <div className="form-group">
                                                    <span className="labeltext">Contact</span>
                                                    <input className="form-control" type="text" name="delivery_contact" value={this.state.delivery_contact} readOnly/>
                                                </div>
                                                <div className="form-group">
                                                    <span className="labeltext">Phone</span>
                                                    <input className="form-control" type="text" name="delivery_phone" value={this.state.delivery_phone} readOnly/>
                                                </div>
                                                <div className="form-group">
                                                    <span className="labeltext">Company</span>
                                                    <input className="form-control" type="text" name="delivery_company" value={this.state.delivery_company} readOnly/>
                                                </div>
                                                <div className="form-group">
                                                    <span className="labeltext">Address</span>
                                                    <input className="form-control" type="text" name="delivery_address1" value={this.state.delivery_address1} readOnly/>
                                                    <input className="form-control" type="text" name="delivery_address2" value={this.state.delivery_address2} readOnly/>
                                                </div>
                                                <div className="form-group">
                                                    <span className="labeltext">Suburb</span>
                                                    <input className="form-control" type="text" name="delivery_suburb" value={this.state.delivery_suburb} readOnly/>
                                                </div>
                                                <div className="form-group">
                                                    <span className="labeltext">Instructions</span>
                                                    <textarea className="form-control" rows="3" name="delivery_instructions" value={this.state.delivery_instructions} readOnly/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-12">
                                        <div className="row h3">
                                            <div className="col-xs-12">Goods</div>
                                            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-2">
                                                <div className="form-group">
                                                    <label>Item Type</label>
                                                    <input className="form-control" type="text" name="item_type" value={this.state.item_type} readOnly/>
                                                </div>                                    
                                            </div>                                    
                                            <div className="col-xs-6 col-sm-3 col-md-2 col-lg-2">
                                                <div className="form-group">
                                                    <label>Quantity</label>
                                                    <input className="form-control" type="text" name="quantity" value={this.state.quantity} readOnly/>
                                                </div>                                    
                                            </div>
                                            <div className="col-xs-3 col-sm-3 col-md-3 col-lg-2">
                                                <div className="form-group">
                                                    <label>Weight</label>
                                                    <input className="form-control" type="text" name="weight" value={this.state.weight} readOnly/>
                                                </div>                                    
                                            </div>
                                            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                                                <div className="form-group">
                                                    <label>Vehicle type suitable for pickup</label>
                                                    <input className="form-control" type="text" name="vehicle_type" value={this.state.vehicle_type_descr} readOnly/>
                                                </div>                                    
                                            </div>
                                            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                                                <div className="padding-md-t40"></div>
                                                <div>
                                                    <input type="checkbox" className="pseudo-checkbox sr-only" name="dangerous_goods" checked={this.state.dangerous_goods} readOnly/>
                                                    <label>Dangerous Goods</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xs-12 col-sm-4 col-lg-3">
                            <div className="row h3">
                                <div className="col-xs-12">Job Status</div>
                            </div>
                            <div className="row">
                                <div className="col-xs-12">
                                    <div className="form-group">
                                        <span className="labeltext">Ready Time</span>
                                        <input className="form-control" type="text" name="pickup_time" value={this.state.ready_datetime} readOnly/>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-xs-12">
                                    <div className="form-group">
                                        <span className="labeltext">Pickup Time</span>
                                        <input className="form-control" type="text" name="pickup_time" value={this.state.pickup.time} readOnly/>
                                    </div>
                                    <div className="form-group">
                                        <span className="labeltext">Delivery Time</span>
                                        <input className="form-control" type="text" name="delivery_time" value={this.state.delivery.time} readOnly/>
                                    </div>
                                </div>
                            </div>
                            {   canViewSignature &&
                                <div className="row">
                                    <div className="col-xs-12">
                                        <div className="form-group">
                                            <span className="labeltext">Name</span>
                                            <input className="form-control" type="text" name="delivered_sig_name" value={this.state.delivered_sig_name} readOnly/>
                                        </div>
                                    </div>
                                </div>
                            }
                            { canViewSignature &&
                                <div className="row">
                                    <div className="col-xs-12">
                                        <div className="form-group">
                                            <span className="labeltext">Signature</span>
                                            <br/>
                                            {signatures}
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                        <div className="col-xs-12 col-sm-4 col-lg-3">
                            <div className="row h3">
                                <div className="col-xs-12">Service</div>
                            </div>
                            <div className="row">
                                <div className="col-xs-12">
                                    <div className="form-group">
                                        <span className="labeltext">Service Type</span>
                                        <input className="form-control" type="text" name="service" value={this.state.service} readOnly/>
                                    </div>
                                </div>
                            </div>
                            {
                                canViewPrice &&
                                <div className="row">
                                    <div className="col-xs-4 col-sm-6 col-lg-4">
                                        <div className="form-group">
                                            <span className="labeltext">Buy Price</span>
                                            <input className="form-control" type="text" name="price" value={this.formatter.format(this.state.price)} readOnly/>
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-sm-6 col-lg-4">
                                        <div className="form-group">
                                            <span className="labeltext">VFR</span>
                                            <input className="form-control" type="text" name="vfr" value={this.formatter.format(this.state.vfr)} readOnly/>
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-sm-6 col-lg-4">
                                        <div className="form-group">
                                            <span className="labeltext">Total</span>
                                            <input className="form-control" type="text" name="total" value={this.formatter.format(this.state.total)} readOnly/>
                                        </div>
                                    </div>
                                </div>
                            }
                            {
                                canViewPrice && this.state.markupPercent > 0 &&
                                <div className="row">
                                    <div className="col-xs-4 col-sm-6 col-lg-4">
                                        <div className="form-group">
                                            <span className="labeltext">Sell Price</span>
                                            <input className="form-control" type="text" name="price" value={this.formatter.format(this.applyMarkup(this.state.price))} readOnly/>
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-sm-6 col-lg-4">
                                        <div className="form-group">
                                            <span className="labeltext">VFR</span>
                                            <input className="form-control" type="text" name="vfr" value={this.formatter.format(this.applyMarkup(this.state.vfr))} readOnly/>
                                        </div>
                                    </div>
                                    <div className="col-xs-4 col-sm-6 col-lg-4">
                                        <div className="form-group">
                                            <span className="labeltext">Total</span>
                                            <input className="form-control" type="text" name="total" value={this.formatter.format(this.applyMarkup(this.state.total))} readOnly/>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const AuthenticatedJobPage = withAuthenticatedUser(withRouter(JobPage));

export { AuthenticatedJobPage as JobPage };